"use client";

import { ConsentManagerCallbacks } from "@c15t/nextjs/client";
import {
	ConsentManagerDialog,
	ConsentManagerProvider,
	CookieBanner,
} from "@c15t/react";

export default function ConsentProvider({
	children,
}: { children: React.ReactNode }) {
	return (
		<ConsentManagerProvider
			options={{
				// mode: "c15t",
				// backendURL: "/api/c15t",
				mode: "offline",
				consentCategories: ["necessary", "marketing"],
				ignoreGeoLocation: true,
			}}
		>
			<CookieBanner />
			<ConsentManagerDialog />
			<ConsentManagerCallbacksClient />

			{children}
		</ConsentManagerProvider>
	);
}

export function ConsentManagerCallbacksClient() {
	return (
		<ConsentManagerCallbacks
			callbacks={{
				onBannerFetched(response) {
					// console.log("Consent banner fetched", response);
				},
				onConsentSet(response) {
					// console.log("onConsentSet", response);
				},
				onError(response) {
					// console.log("Error", response);
				},
			}}
		/>
	);
}
